import { FC, useCallback, useMemo } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { startLinkageSessionActionCreator } from 'actions/linkageActions'
import { createCompositeId, accountActionsMap } from 'helpers/linkageHelpers'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

type AccountActionCreateManualHandlerProps = {
  accountInfo: MixedAccountsTableItem
}

export const AccountActionCreateManualHandler: FC<AccountActionCreateManualHandlerProps> = (props) => {
  const { children, accountInfo } = props
  const { providerAccountState } = accountInfo
  const { actions } = providerAccountState

  const dispatch = useStoreDispatch()

  const handleClick = useCallback(() => {
    dispatch(
      startLinkageSessionActionCreator.request({
        cid: createCompositeId('manual-balance-account', null),
      })
    )
  }, [dispatch])

  const isExist = useMemo(() => {
    const { suggest_manual_account } = accountActionsMap(actions)
    return !!suggest_manual_account
  }, [actions])

  if (!isExist) {
    return null
  }

  return (
    <div onClick={ handleClick }>
      { children }
    </div>
  )
}
